import './FilterSlider.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {connect} from "react-redux";
import Slider from "react-slick";
import {useRef, useState} from "react";
import {SliderButton} from "../ui-elements/buttons/Buttons";
import {FilterArrIcon} from "../../assets/images";
import {AREA_TYPES} from "../../constants/constants";
import {useNavigate} from "react-router-dom";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";

function FilterSlider(props) {
    const {staticTexts, minPrices} = props
    let sliderRef = useRef(null);
    const [slideIndex, setSlideIndex] = useState(0);
    const navigate = useNavigate();
    const filters = [
        {
            id: '0',
            static_text: 'offer_office_title',
            type: AREA_TYPES.OFFICE.key,
            valueKey: 'office',
        },
        // {
        //     id: '2',
        //     static_text: 'offer_parking_title',
        //     type: AREA_TYPES.PARKING.key,
        //     valueKey: 'parking',
        // },
        // {
        //     id: '1',
        //     static_text: 'offer_restaurant_title',
        //     type: AREA_TYPES.RESTAURANT.key,
        //     valueKey: 'restaurant',
        // },
        {
            id: '3',
            static_text: 'offer_apartment_1_title',
            roomsCount: [1],
            type: AREA_TYPES.APARTMENT.key,
            valueKey: 'room1',
        },
        {
            id: '4',
            static_text: 'offer_apartment_2_title',
            roomsCount: [2],
            type: AREA_TYPES.APARTMENT.key,
            valueKey: 'room2',
        },
        {
            id: '5',
            static_text: 'offer_apartment_3_title',
            roomsCount: [3],
            type: AREA_TYPES.APARTMENT.key,
            valueKey: 'room3',
        },
        {
            id: '6',
            static_text: 'offer_apartment_4_title',
            roomsCount: [4],
            type: AREA_TYPES.APARTMENT.key,
            valueKey: 'room4',
        },
    ]


    const nextSlide = () => {
        sliderRef.slickGoTo(+slideIndex + 1);
    };

    const prevSlide = () => {
        sliderRef.slickGoTo(slideIndex - 1);
    };

    const settings = {
        dots: false,
        arrows: false,
        speed: 500,
        ref: slider => (sliderRef = slider),
        variableWidth: true,
        infinite: false,
        centerMode: false,
        slidesToShow: 1.4,
        slidesToScroll: 1,
        beforeChange: (current, next)=>{ setSlideIndex(next)},
    };

    const filtersList = filters?.filter(item => minPrices?.[item?.valueKey]);

    return <div className="FilterSlider">
        <div className={`filter-wrapper `}>
            {/*${!slideIndex ? 'more_width' : ''}*/}
            {!!filtersList?.length && <Slider{...settings}>
                {filtersList?.map(item => {
                    return <div key={item?.valueKey} className={'FilterCard'} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const state = {
                            type: item.type,
                        }
                        if (item.type === AREA_TYPES.APARTMENT?.key) {
                            state.roomsCount = item.roomsCount;
                        }
                        navigate(getUrlWithLocal('/filter'), {state: state})
                    }}>
                        {staticTexts?.[item.static_text]} <span>{minPrices[item.valueKey]} ₽</span> <FilterArrIcon/>
                    </div>
                })}
            </Slider>}
            <span className={'shadow'}/>
        </div>
        {filtersList?.length &&
            <div className={'filter-arrows'}>
                <button className={`slider-btn  prev-btn  ${!slideIndex ? 'disable' : ''}`}
                        onClick={prevSlide}
                        disabled={slideIndex === 0}
                >
                    {'<'}
                </button>
                <button
                    className={`slider-btn next-btn`}
                    disabled={window.innerWidth  < 700 ? false : filtersList?.length < 4}
                    onClick={nextSlide}>
                    >
                </button>
            </div>
            // <SliderButton
            //     className={'filter-arrows'}
            //     cbPrev={(e) => {
            //         e.preventDefault();
            //         e.stopPropagation();
            //         sliderRef.slickPrev()
            //     }}
            //     cbNext={(e) => {
            //         e.preventDefault();
            //         e.stopPropagation();
            //         sliderRef.slickNext()
            //     }}
            // />
        }
    </div>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'areas',
    'minPrices',
]);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FilterSlider);
